import { isProblem, isValidation } from "@kodall/kodall-client/dist/types";
import { intercept } from "~/service/kodall-client";

type Account = {
  key?: number;
  ch_sms: boolean | number;
  ch_email: boolean | number;
  ch_web: boolean | number;
  terms_conditions: boolean | number;
  gdpr: boolean | number;
  propria_raspundere: boolean | number;
  email?: string;
  sms_no?: string;
  id_client?: number
  id_operator?: number
  state?: string
};

const account = ref<Account | null>(null)

export const useAccount = () => {
  const kc = useSecurity().kc.value;
  const auth = useAuthStore()
  const getAccount = async () => {
    var result = await intercept<Account[]>(() =>
      kc.fetch<Account>(`
        FETCH account (key, ch_sms, ch_email, ch_web, email, sms_no, state, terms_conditions, gdpr, propria_raspundere) {
          client TO id_client LINK TYPE LEFT (key AS id_client),
          operator TO id_operator LINK TYPE LEFT (key AS id_operator)
        } FILTER AND (id_user == ${auth.user?.userKey})
        `)
    );
    if(result.length !== 0 && result[0]) {
      account.value = result[0]
    }
  };

  const innitAccount = async () => {
    await getAccount()
    if(account.value?.id_client || account.value?.id_operator) return
    if(!auth.user) return

    // var result = await kc.workflow<Account> ("Account", "create", {})

    // if(isProblem(result) || isValidation(result)) {
    //   console.error(result.detail)
    //   return
    // }

    // account.value = result
  }

  const updateAccount = async (account: Account) => {
   var result = await kc.update({entity_name: "account", properties: account })

    if(isProblem(result) || isValidation(result)) {
      console.error(result.detail)
      return
    }

    await getAccount()
  }

  innitAccount().catch(console.error)
  return { updateAccount, account };
};
